module.exports = __webpack_public_path__ + "static/media/prb-nutri-brinde-caneta-personalizado-768x591.f256f0c0.jpg";